import api from '@/services/api'

export const commentGoal = async (targetId, commentText) => {
    try {
        const resp = await api.post('/comments', {
            commentable_type: 'goal',
            commentable_id: targetId,
            content: commentText,
        })
        return await resp.data.data
    } catch (e) {
        console.error(e)
        throw e
    }
}
